export default __webpack_public_path__ + "static/media/detail_mobile_12_2.a64dd8c8.jpg";